import { type PropsWithChildren } from 'react';
import { LocationInfoWrapper, StyledGroupedListContent, StyledLabel } from './style';

type DisplayLocationProps = PropsWithChildren<{
  label: string;
  showBold: boolean;
  inactive: boolean;
  value?: string;
}>;

export const DisplayLocation = ({
  label,
  children,
  showBold,
  value,
  inactive,
}: DisplayLocationProps) => {
  return (
    <LocationInfoWrapper>
      <StyledGroupedListContent>
        <StyledLabel
          data-testid={'location-picker-label-' + (value ?? '')}
          showBold={showBold}
          inactive={inactive}
        >
          {label}
        </StyledLabel>
        {children}
      </StyledGroupedListContent>
    </LocationInfoWrapper>
  );
};
